(function () {
	let trioBundleEditKey = new URL(window.location.href).searchParams.get('edit');
	let trioBundleEditItem = null;
	let trioBundleDefaultButtonText = null;

	function getTrioCartProperty(properties, propertyName) {
		if (!properties) return '';
		if (Array.isArray(properties)) {
			const property = properties.find(function (property) {
				return property && property[0] === propertyName;
			});
			return property ? property[1] : '';
		}
		return properties[propertyName] || '';
	}

	function getTrioEditComponents(bundleItem) {
		if (!bundleItem || !Array.isArray(bundleItem.item_components)) return [];
		return bundleItem.item_components.filter(function (itemComponent) {
			return parseInt(itemComponent.id, 10) !== parseInt(bundleItem.id, 10)
				&& getTrioCartProperty(itemComponent.properties, '_bundle_type') === 'trio';
		});
	}

	function updateTrioProductSlider() {
		var swiperEl = document.querySelector('.swiper-trio');
		var slider = swiperEl && swiperEl.swiper;
		if (slider) slider.update();
	}

	function clearTrioBundleEditMode() {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.delete('edit');
		window.history.replaceState(null, '', currentUrl);
		trioBundleEditKey = null;
		trioBundleEditItem = null;
	}

	function selectTrioBundleComponents(bundleItem) {
		const trioComponents = getTrioEditComponents(bundleItem);
		const selectedCards = [];
		const selectedRadios = [];
		if (!trioComponents.length) return false;

		trioComponents.forEach(function (itemComponent) {
			const radio = document.querySelector('.trio-bundle-container input[data-variant-id="' + itemComponent.id + '"]');
			const card = radio && radio.closest('.product__card-alt');
			if (!radio || !card) return;
			selectedRadios.push(radio);
			if (selectedCards.indexOf(card) === -1) selectedCards.push(card);
		});

		if (!selectedCards.length || selectedRadios.length !== trioComponents.length) return false;

		document.querySelectorAll('.trio-bundle-container .product__card-alt').forEach(function (card) {
			card.classList.add('hidden');
		});
		document.querySelectorAll('.swiper-trio .swiper-slide').forEach(function (slide) {
			slide.classList.add('hidden');
		});

		selectedCards.forEach(function (card) {
			const handle = card.dataset.productHandle;
			const productSwitch = card.querySelector('.trio-product-switch');
			card.classList.remove('hidden');
			if (handle && productSwitch) productSwitch.value = handle;
			if (handle) {
				const slide = document.querySelector('.swiper-trio .swiper-slide[data-handle="' + handle + '"]');
				if (slide) slide.classList.remove('hidden');
			}
		});

		selectedRadios.forEach(function (radio) {
			radio.checked = true;
			radio.dispatchEvent(new Event('change', { bubbles: true }));
		});

		updateTrioProductSlider();
		return true;
	}

	function initTrioBundleEditMode() {
		if (!trioBundleEditKey || !document.querySelector('.product-form__trio')) return;
		trioBundleDefaultButtonText = $('.product-form__trio span').first().text();

		fetch('/?view=cart_js')
			.then(function (response) {
				return response.json();
			})
			.then(function (cartData) {
				trioBundleEditItem = cartData.items.find(function (item) {
					return item.key === trioBundleEditKey;
				});
				if (!trioBundleEditItem || !Object.keys(trioBundleEditItem).length) return;
				if (!selectTrioBundleComponents(trioBundleEditItem)) {
					trioBundleEditItem = null;
					return;
				}
				$('.product-form__trio span').text('Update Bundle');
			})
			.catch(function (error) {
				console.error('Error:', error);
			});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTrioBundleEditMode);
	} else {
		initTrioBundleEditMode();
	}

	$(document).on('click', '.product-form__trio', function(e){
		e.preventDefault();
		var $this = $(this);
		if ($this.hasClass('disabled')) return;
		const _timestamp = new Date().getTime();
		var $data = [];
		let childIds = [];
		let childProductNames = [];
		const isTrioEditMode = trioBundleEditKey && trioBundleEditItem && Object.keys(trioBundleEditItem).length;
		var $originalText = $this.find('span').text();
		const $restoreText = isTrioEditMode && trioBundleDefaultButtonText ? trioBundleDefaultButtonText : $originalText;

		function restoreTrioButton(statusText) {
			$this.find('span').text(statusText);
			setTimeout(function(){
				$this.find('span').text($restoreText);
				$this.removeClass('disabled');
			}, 500);
		}

		$this.find('span').text(isTrioEditMode ? 'Updating...' : 'Adding...');
		$this.addClass('disabled');
		$('.trio-bundle-container .product__card-alt:not(.hidden)').each(function () {
			var $this = $(this);
			const $variant = $this.data('variant-id');
			const $name = $this.data('name') + '|' + $this.data('type') + '||' + $this.data('image');
			$data.push({
				'quantity': 1,
				'id': $variant,
				properties: {
					_bundle_type: 'trio',
					_bundle_product: 'Yes',
					_unique_bundle_id: _timestamp,
					_bundle_item: 'Yes',
				}
			});
			childIds.push($variant);
			childProductNames.push($name);
		});
		const parentVariant = parseInt($('input[name="id"]').val(), 10);
		$data.push({
			'quantity': 1,
			'id': parentVariant,
			properties: {
				_bundle_type: 'trio',
				_bundle_product: 'Yes',
				_unique_bundle_id: _timestamp,
				_bundle_item: 'Yes',
			}
		});
		const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		const sections = cart_holder.getSectionsToRender().map((section) => section.id);
		cart_holder.setActiveElement(document.getElementById('CartDrawer'));
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: {
				items: $data,
				sections,
				sections_url: window.location.pathname + (window.location.search || '')
			},
			success: function (response) {
				if (response.status) {
					restoreTrioButton($restoreText);
					alert(response.description || 'An error has occurred.')
					return;
				}
				if (cart_holder && cart_holder.classList.contains('is-empty')) {
					cart_holder.classList.remove('is-empty');
				}

				if (isTrioEditMode) {
					let updates = {};
					updates[trioBundleEditKey] = 0;

					fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							updates, sections,
							sections_url: window.location.pathname + (window.location.search || '')
						})
					})
						.then(function (response) {
							return response.json();
						})
						.then(function (response) {
							if (cart_holder && cart_holder.classList.contains('is-empty')) {
								cart_holder.classList.remove('is-empty');
							}
							clearTrioBundleEditMode();
							cart_holder.renderContents(response);
							restoreTrioButton('Updated!');
						})
						.catch(function (error) {
							console.error('Error:', error);
							restoreTrioButton($restoreText);
						});
				} else {
					cart_holder.renderContents(response);
					restoreTrioButton('Added!');
				}
			},
			error: function (response, a, b) {
				restoreTrioButton($restoreText);
				if (response) {
					alert(response?.responseJSON?.description || 'An error has occurred.')
					return;
				}
			}
		});
	});

	$(document).on('click', '.view-trio-details', function (e) {
		e.preventDefault();
		var id = $(this).data('id');
		var swiperEl = document.querySelector('.swiper-trio');
		var slider = swiperEl && swiperEl.swiper;
		if (!slider) return;
		var visibleSlides = Array.from(slider.slides).filter(function (slide) {
			return !slide.classList.contains('hidden');
		});
		var slideIndex = -1;
		visibleSlides.forEach(function (slide, i) {
			if (slide.dataset.id === id) slideIndex = i;
		});
		if (slideIndex === -1) return;
		slider.slideTo(slideIndex, 300);
		var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
		var topOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--top-offset'), 10) || 0;
		$('html, body').animate({
			scrollTop: $('.trio-product-details-slider').offset().top - headerHeight - topOffset
		}, 400);
	});

	$(document).on('click', '.trio-product-right h4', function(){
		$(this).toggleClass('open-next-tab');
	});
	$(window).on('load', function(){
		$('.product-form__trio').removeAttr('disabled');
	});
})();
